module.exports = __webpack_public_path__ + "img/img_left_nav_notify.71a83801.svg";